(function () {

  'use strict';

  eclipseApp.directive('refillCurrency', ['$http', '$rootScope', '$filter', '$sce', '$translate', 'uteLocale', function ($http, $rootScope, $filter, $sce, $translate, uteLocale) {

    return {
      scope: {
        fontSize: '@',
        price: '@',
        frequency: '@',
        tax: '='
      },
      //scope: true,
      transclude: false,
      replace: true,
      template: '<span ng-style="{fontSize: fontSize};"><ins ng-bind-html="currencyValue"></ins></span>',
      restrict: 'EA',
      link: function ($scope, $element, $attrs) {

        /**
         * Check if fontSize attribute exists or is set
         * @scope.fontSize
         */
        $scope.fontSize = $scope.fontSize || '5rem';

        var buildCurrency = function (value) {

          var currencySymbol = '<sup>$</sup>',
            taxText = '',
            translatedFrequency,
            dollarValue,
            freq = '';

          var toEnglish = function () {
            var priceArray = value.toString().replace('$', '').split('.');
            $scope.currencyValue = $sce.trustAsHtml(currencySymbol + priceArray[0] + taxText + freq);
          };

          var toFrench = function () {
            var priceArray = value.toString().replace('$', '').split(',');
            $scope.currencyValue = $sce.trustAsHtml(priceArray[0] + currencySymbol + taxText + freq);
          };

          $scope.getCurrencyValue = function () {

            if ($scope.tax) {
              var tax = parseFloat($scope.tax);
              if (tax && _.isNumber(tax)) {
                taxText = '<span class="plux-tax-text">+' + tax.toFixed(2).toString() + '</span>';
              } else {
                var plusTax = uteLocale.language === 'en' ? '+ taxes' : '+ taxes';
                taxText = '<span class="plux-tax-text">' + plusTax + '</span>';
              }
            }

            if (uteLocale.language === 'en') {
              toEnglish();
            } else if (uteLocale.language === 'fr') {
              toFrench();
            } else {
              toEnglish();
            }
          };

          if ($scope.frequency) {
            $translate.use(uteLocale.language);
            $translate($scope.frequency).then(function (result) {
              freq = '<sub>' + result + '</sub>';
              $scope.getCurrencyValue();
            });

          } else {

            $scope.getCurrencyValue();

          }

        };


        /**
         * Watch for Locale Change & Initialization. buildCurrency when everything is ok
         * @scope.price
         */
        $scope.$watch(function () {

          var priceNumber = Number($scope.price.replace('$', ''));
          $scope.price = !isNaN(priceNumber) ? $scope.price : '$0.00';
          $scope.price = $scope.price.replace('$', '').toString();

          return $filter('currency')($scope.price, '$');

        }, function (value) {
          buildCurrency(value);
        });

      }

    };
  }]);

})();
